import { BaseModel } from "@/models/base.model"
import { type IProjectRentalIntakeItem } from "@/interfaces/api/project-rental-intake-item.interface"

export class ProjectRentalIntakeItem extends BaseModel implements IProjectRentalIntakeItem {
  public static className = "ProjectRentalIntakeItem" // Used for socket communication.
  public static verboseName = "projectinhuurafspraak"

  project: string
  rentalIntakeItem: string

  unitPricePerDay: string

  constructor(projectRentalIntakeItem: IProjectRentalIntakeItem) {
    super(projectRentalIntakeItem)

    this.project = projectRentalIntakeItem.project
    this.rentalIntakeItem = projectRentalIntakeItem.rentalIntakeItem

    this.unitPricePerDay = projectRentalIntakeItem.unitPricePerDay
  }
}
